import * as consts from '@/utils/constants'
import { TemplatesStateInterface } from '@/models/store/TemplatesState.interface'
import {
  RichCardInterface,
  RichCardActionInterface
} from '@/models/templates/RichCard.interface'
import { RichCardActionList } from '@/models/rich_cards/RichCardActionPayload.interface'

const emptyRichCard = (): RichCardInterface => ({
  title: null,
  imageId: null,
  mediaUrl: null,
  position: 0,
  buttons: []
})

const emptyRcsAction = (position: number): RichCardActionInterface => ({
  text: '',
  actionType:
    consts.RCS_ACTION_OPEN_URL as RichCardActionInterface['actionType'],
  url: '',
  phoneNumber: null,
  position
})

const richCardAt = (state: TemplatesStateInterface, index: number) =>
  state.template.richCards?.[index]

const rcsActionsFor = (
  state: TemplatesStateInterface,
  list: RichCardActionList
): RichCardActionInterface[] | undefined =>
  list === 'buttons' ? richCardAt(state, 0)?.buttons : state.template.rcsActions

const maxFor = (list: RichCardActionList) =>
  list === 'buttons'
    ? consts.RICH_CARD_MAX_BUTTONS
    : consts.RICH_CARD_MAX_RCS_ACTIONS

const reindex = (actions: RichCardActionInterface[]) =>
  actions.forEach((action, index) => {
    action.position = index
  })

export {
  emptyRichCard,
  emptyRcsAction,
  richCardAt,
  rcsActionsFor,
  maxFor,
  reindex
}
